<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div
      class="modal fade"
      id="modal-form-reporte-cumplimiento"
      style="background-color: #00000082"
      tabindex="-1"
      role="dialog"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-header bg-geogo-top-left pt-2 pb-2">
            <h4 class="modal-title text-white">Generar Reporte Cumplimiento</h4>
            <button
              type="button"
              class="close text-white"
              data-dismiss="modal"
              aria-label="Close"
              id="close-modal"
              ref="closeModal1"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="tab-Filtros"
                  data-toggle="tab"
                  href="#Filtros"
                  >Filtros
                </a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade active show" id="Filtros">
                <div class="card-body">
                  <div class="form-group row">
                    <label for="id_nomina" class="col-md-5">NOMINACION</label>
                    <v-select
                      :class="$store.getters.getDarkMode ? 'dark-vselect' : ''"
                      v-model="nominacion"
                      placeholder="Nominaciones"
                      label="descripcion"
                      id="id_nominacion"
                      class="form-control form-control-sm p-0"
                      :options="listasForms.nominaciones"
                      :filterable="true"
                      @input="getSelectNominaciones()"
                    ></v-select>
                  </div>
                  <div class="form-group row">
                    <label for="id_nomina" class="col-md-5">Fecha corte</label>
                    <input
                      type="date"
                      v-model="form.fecha_corte"
                      class="form-control form-control-sm"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer justify-content-between">
            <div>
              <button
                type="button"
                class="btn btn-sm bg-navy"
                @click="generarListadoExcel()"
                v-if="
                  $store.getters.can(
                    'hidrocarburos.reportes.reporteCumplimiento'
                  )
                "
              >
                Generar Listado
                <i class="fas fa-file-download"> </i>
              </button>
            </div>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "../../../../components/Loading";
import vSelect from "vue-select";
export default {
  name: "ReporteCumplimientoExport",
  components: {
    Loading,
    vSelect,
  },
  data() {
    return {
      cargando: false,
      nominacion: {},
      form: {
        id_nominacion: null,
        fecha_corte: null,
      },
      listasForms: {
        nominaciones: [],
      },
    };
  },

  methods: {
    getSelectNominaciones() {
      this.form.nominacion = {};
      this.form.id_nominacion = null;
      if (this.nominacion) {
        this.form.nominacion = this.nominacion;
        this.form.id_nominacion = this.nominacion.id;
      }
    },

    generarListadoExcel() {
      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/hidrocarburos/reportes/reporteCumplimiento",
        data: { nominacion_id: this.form.id_nominacion, fecha_corte: this.form.fecha_corte },
      })
        .then((response) => {
          let data = response.data;
          this.cargando = false;
          location.href = data.url;
        })
        .catch((e) => {
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
          this.cargando = false;
        });
    },
  },
};
</script>
